import React, { useState } from "react";
import { toast } from "sonner";
import { HandCoins, Heart } from "lucide-react";
import api from "@/lib/api";

const PRESETS = [5, 10, 20];

/**
 * Tip button — after a booking/order is completed, the customer can send
 * a tip through Stripe test checkout. 100% goes to the provider (default
 * tip_treatment = provider_100_no_commission).
 */
export default function TipButton({ purpose = "tip", targetId, providerName, testId = "tip-button" }) {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState("");
  const [sending, setSending] = useState(false);

  const send = async (amt) => {
    if (!amt || amt <= 0) return toast.error("Choose an amount");
    setSending(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        purpose: "tip",
        target_id: targetId,
        tip_amount: Number(amt),
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.error || "Could not start tip checkout");
      setSending(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid={testId}
        className="inline-flex items-center gap-2 rounded-full border border-[#165a71]/30 bg-[#165a71]/5 text-[#165a71] px-4 py-2 text-sm font-medium hover:bg-[#165a71]/10"
      >
        <Heart className="h-4 w-4" /> Send a tip
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-2xl w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()} data-testid="tip-modal">
            <div className="flex items-center gap-2 mb-3"><HandCoins className="h-5 w-5 text-[#165a71]" /><div className="font-display text-lg font-semibold text-[#071b22]">Tip {providerName || "your provider"}</div></div>
            <div className="text-xs text-[#252A34]/70 mb-3">100% of your tip goes to the provider. No platform commission applies.</div>
            <div className="grid grid-cols-3 gap-2 mb-3">
              {PRESETS.map((v) => (
                <button key={v} onClick={() => send(v)} disabled={sending} className="rounded-xl border border-slate-200 py-2 text-sm font-medium hover:border-[#165a71]/40" data-testid={`tip-preset-${v}`}>${v}</button>
              ))}
            </div>
            <div className="flex items-center gap-2">
              <input type="number" value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Custom amount" className="flex-1 rounded-xl border border-slate-200 px-3 py-2 text-sm" data-testid="tip-custom-input" />
              <button onClick={() => send(custom)} disabled={sending || !custom} className="rounded-full bg-[#165a71] text-white px-4 py-2 text-sm font-medium disabled:opacity-60" data-testid="tip-submit">Send</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
